angular.module('app').controller('ImportPhotosCtrl', function(
    $scope, $http, $route, $mdDialog, $mdToast, $location, $timeout
) {
    var main = this;
    main.error = false;
    main.event_id = $route.current.params.event_id;
    main.photos = [];
    main.too_small = [];
    main.too_large = [];
    main.missing_size = [];

    main.magnifierRatio = 2.8;
    main.lensSize = 200;

    main.initMagnifier = function(id) {
        var img = document.getElementById(id);
        var lens = document.getElementById('lens-' + id);
        
        if (img && lens) {
            lens.style.backgroundSize = (img.width * main.magnifierRatio) + "px " + (img.height * main.magnifierRatio) + "px";
        }
    };

    main.magnify = function(event, id) {
        var img = document.getElementById(id);
        var lens = document.getElementById('lens-' + id);
        
        if (img && lens) {
            var rect = img.getBoundingClientRect();
            var x = event.clientX - rect.left;
            var y = event.clientY - rect.top;
            
            var lensX = x - (main.lensSize / 2);
            var lensY = y - (main.lensSize / 2);
            
            if (lensX < 0) lensX = 0;
            if (lensY < 0) lensY = 0;
            if (lensX > img.width - main.lensSize) lensX = img.width - main.lensSize;
            if (lensY > img.height - main.lensSize) lensY = img.height - main.lensSize;
            
            lens.style.left = lensX + "px";
            lens.style.top = lensY + "px";
            
            var bgX = -x * main.magnifierRatio + (main.lensSize / 2);
            var bgY = -y * main.magnifierRatio + (main.lensSize / 2);
            lens.style.backgroundPosition = bgX + "px " + bgY + "px";
        }
    };

    main.organizePhotos = function(photos) {
        var out = [];
        var cur = {'photos': [], 'id': 'init'};
        photos.forEach(function(photo, index) {
            if(((photo.barcode || photo.missing_barcode) && photo.signup && (!photo.barcode_method || !photo.barcode_method.startsWith('gemini'))) || ((photo.classes && photo.classes.length > 0) || photo.show_in_all_galleries)) {
                if(cur.photos.length > 0) {
                    out.push(cur);
                }

                if(photo.classes || photo.show_in_all_galleries) {
                    out.push({'photos': [], 'class_photo': photo, 'classes': photo.classes, 'index': index, 'id': photo.name});
                    cur = {'photos': []};
                    return;
                } else {
                    cur = {'photos': [], 'barcode': photo, 'index': index,  'id': photo.name};
                }

                if(photo.barcode) {
                    return;
                }
            }

            cur.photos.push({'photo': photo, 'index': index});
        });

        if(cur.photos.length > 0) {
            out.push(cur);
        }
        return out;
    };

    main.loading = false;

    main.update1Star = function(photo, chosen) {
        photo.barcode = chosen.id;
        photo.signup = chosen;
        main.photos = main.organizePhotos(main.rawPhotos);
    }

    main.import = function(group) {
        if(main.loading || main.job_id) {
            var alert = $mdToast.simple().textContent("Import already in progress - please wait for current import to complete");
            $mdToast.show(alert);
            return;
        }

        var isFullImport = (group == null);
        main.single_group = group;

        main.loading = $http({
            'method': 'POST',
            'url': '/api/v1/admin/event/' + main.event_id + '/import-photos',
            'data': isFullImport ? main.photos : [group]
        }).then(
            function(response) {
                if(response.data.imported) {
                    main.finishImport(response.data.imported, isFullImport);
                } else {
                    main.job_id = response.data.job_id;
                    main.pollJobStatus(main.job_id, isFullImport);
                }
            },
            function(error) {
                main.loading = false;
                var alert = $mdToast.simple().textContent("Failed to start import: " + (error.data.message || "Unknown error"));
                $mdToast.show(alert);
            }
        );
    };

    main.finishImport = function(importCount, isFullImport) {
        main.loading = false;
        var alert = $mdToast.simple().textContent(`Imported ${importCount} photos`);
        $mdToast.show(alert);

        if (isFullImport) {
            // Full import - redirect to event page
            $location.url('/event/' + main.event_id);
        } else {
            // Single group import - clean up UI
            var group = main.single_group;
            delete main.rawPhotos[group.index];
            group.photos.forEach(function(photo) {
                delete main.rawPhotos[photo.index];
            });
            main.photos = main.organizePhotos(main.rawPhotos);

            main.job_id = null;
            main.single_group = null;
        }
    }

    main.pollJobStatus = function(jobId, isFullImport) {
        if (!jobId) {
            main.loading = false;
            return;
        }

        $http.get('/api/v1/admin/job/' + jobId + '/status').then(
            function(response) {
                if (response.data.status === 'complete') {
                    main.finishImport(response.data.imported, isFullImport);
                } else if (response.data.status === 'error') {
                    main.loading = false;
                    var alert = $mdToast.simple().textContent("Import failed: " + (response.data.error || "Unknown error"));
                    $mdToast.show(alert);
                    main.job_id = null;
                    main.single_group = null;
                } else {
                    $timeout(function() {
                        main.pollJobStatus(jobId, isFullImport);
                    }, 2000);
                }
            },
            function(error) {
                main.loading = false;
                var alert = $mdToast.simple().textContent(`Error checking import status: ${error.data.message || 'Unknown Error'}`);
                $mdToast.show(alert);
                main.job_id = null;
                main.single_group = null;
            }
        );
    };

    main.markNotBarcode = function(index) {
        main.rawPhotos[index].barcode = false;
        main.rawPhotos[index].missing_barcode = false;
        main.photos = main.organizePhotos(main.rawPhotos);
    };

    main.editBarcode = function(index, missing) {
        var photo = main.rawPhotos[index];
        photo.preview_url = main.previewUrl + "?bucket=franchise-" + main.franchiseId + ".ezgophoto.com&name=" +  photo.name + "&width=600";
        $mdDialog.show({
            'controller': 'BarcodeCtrl',
            'controllerAs': 'main',
            'clickOutsideToClose': true,
            'templateUrl': '/static/admin/templates/barcode.html?v=5',
            'multiple': true,
            'locals': {
                'photo': photo,
                'parent': main,
                'missing': missing
            }
        }).then(
            function() {
                main.photos = main.organizePhotos(main.rawPhotos);
            }
        );
    };

    main.markAsClassPhoto = function(index) {
        var photo = main.rawPhotos[index];
        photo.preview_url = main.previewUrl + "?bucket=franchise-" + main.franchiseId + ".ezgophoto.com&name=" +  photo.name + "&width=600";
        $mdDialog.show({
            'controller': 'ClassCtrl',
            'controllerAs': 'main',
            'clickOutsideToClose': true,
            'templateUrl': '/static/admin/templates/class.html?v=5',
            'multiple': true,
            'locals': {
                'photo': photo,
                'parent': main,
            }
        }).then(
            function() {
                main.photos = main.organizePhotos(main.rawPhotos);
            }
        );
    };

    main.search = function(text) {
        if(text) {
            var params = {'q': text};
            params.event_id = main.event_id;
            return $http({
                'method': 'GET',
                'url': '/api/v1/admin/event_signup/barcode_search',
                'params': params
            }).then(
                function(response) {
                    return response.data.objects;
                }
            );
        }

        return [];
    };

    main.toggleYearbook = function(photo) {
        photo.yearbook_candidate = !photo.yearbook_candidate;
    };

    $http({
        'method': 'GET',
        'url': '/api/v1/admin/event/' + main.event_id
    }).then(
        function(response) {
            main.item = response.data;
        }
    );

    main.loadPhotos = function() {
        main.error = false;
        main.loading = $http({
            'method': 'GET',
            'url': '/api/v1/admin/event/' + main.event_id + '/import-photos'
        }).then(
            function(response) {
                main.loading = false;
                main.previewUrl = $scope.previewUrl;
                main.franchiseId = response.data.franchise_id;
                main.rawPhotos = response.data.photos;
                main.photos = main.organizePhotos(main.rawPhotos);
                main.too_small = response.data.too_small;
                main.too_large = response.data.too_large;
                main.missing_size = response.data.missing_size;
            },
            function(response) {
                main.loading = false;
                if(response.data.message) {
                    main.error = response.data.message;
                }
            }
        );
    }
    main.loadPhotos();
});
